import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const ToolTip = ({
  message,
  iconStyles = {
    height: "14px",
    width: "14px",
    border: "0px",
    color: " var(--text-medium, rgba(1, 1, 2, 0.40))",
  },
}) => {
  return (
    <Tooltip title={message} arrow>
      <IconButton
        sx={{
          paddingTop: "2px",
          "&:hover": { backgroundColor: "transparent" },
        }}
        disableFocusRipple
        disableTouchRipple
      >
        <InfoIcon sx={iconStyles} />
      </IconButton>
    </Tooltip>
  );
};

export default ToolTip;
